<ng-container *ngIf="breadCrumbStateService.breadcrumbsState$ | async as breadcrumbState">
	<folder-breadcrumbs *ngIf="breadcrumbState === VerticalNavState.FOLDER_VIEW"></folder-breadcrumbs>
	<licensing-breadcrumbs *ngIf="breadcrumbState === VerticalNavState.LICENSE_MANAGEMENT_VIEW"></licensing-breadcrumbs>
	<archive-breadcrumbs *ngIf="breadcrumbState === VerticalNavState.ARCHIVE_VIEW"></archive-breadcrumbs>
	<settings-breadcrumbs *ngIf="breadcrumbState === VerticalNavState.USER_SETTINGS"></settings-breadcrumbs>
</ng-container>
